import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import NumberWithCountry from '@/components/profile/numberWithCountry'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"

import '@/pages/profile/sections/common.css'

export default function GuardianContactNumber(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.guardianContactNumber}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <NumberWithCountry
                countryCode={props.guardianCountryCode}
                countryCodePlaceholder={props.whatsAppCountryCodePlaceholder}

                contactNumber={props.guardianContactNumber}
                contactNumberPlaceholder={props.guardianContactNumberPlaceholder}

                onChangeCountryCode={(e: any) => props.handleInputChange(e, listOfSections.guardianDetails.guardianCountryCode)}
                onChangeNumber={(e: any) => props.handleInputChange(e, listOfSections.guardianDetails.guardianContactNumber)}

                readOnly={props.checked}
            />


            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.guardianDetails.guardianContactNumber)}
                />
            </div>
        </div>
    );
}
